/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_INITIAL_STATE = `${ PREFIX_EVENTS_STORE }/WEBSITE_BLOCK/SET_INITIAL_STATE`;

export const SET_WEBSITE_URL = `${ PREFIX_EVENTS_STORE }/SET_WEBSITE_URL`;

export const SET_WEBSITE_LABEL = `${ PREFIX_EVENTS_STORE }/SET_WEBSITE_LABEL`;
